import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// PWA 서비스 워커 등록 (즉시 실행)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('[SW] 서비스 워커 등록 성공:', registration.scope);
        
        // 업데이트 확인 및 즉시 적용
        registration.addEventListener('updatefound', () => {
          console.log('[SW] 새 서비스 워커 업데이트 발견');
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                console.log('[SW] 새 서비스 워커 설치 완료 - 페이지 새로고침');
                // 새 서비스 워커가 준비되면 자동 새로고침
                window.location.reload();
              }
            });
          }
        });

        // 기존 서비스 워커 즉시 업데이트 체크
        registration.update();
      })
      .catch((error) => {
        console.log('[SW] 서비스 워커 등록 실패:', error);
      });
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// 서비스 워커 등록 (PWA) - 즉시 실행
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js')
    .then((registration) => {
      console.log('[SW] 서비스 워커 등록 성공:', registration.scope);
    })
    .catch((error) => {
      console.log('[SW] 서비스 워커 등록 실패:', error);
    });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
